import { z } from "zod";
import { Slug } from "./directory.js";
const Text = (max = 5000) => z.string().trim().max(max);
/** Web forms send numbers as text and blanks as null; JSON files send numbers. */
const numeric = (v) => (v === null || v === "" ? undefined : typeof v === "string" ? Number(v) : v);
const Weight = z.preprocess(numeric, z.number().min(0.1, "Weight is at least 0.1").max(5, "Weight is at most 5").optional());
const Sort = z.preprocess(numeric, z.number().int("Sort order is a whole number").min(0).max(9999).optional());
/**
 * questionsToAsk and infoNeeded are stored one item per line. summary, questionsToAsk and infoNeeded show to reps
 * without a source, so they never state eligibility rules, amounts, limits or deadlines. sort: lower comes first.
 */
export const ProblemInput = z.object({
    slug: Slug, title: Text(200).min(1), summary: Text(600).nullable().optional(),
    questionsToAsk: Text().nullable().optional(), infoNeeded: Text().nullable().optional(),
    guidance: Text().nullable().optional(), alternatives: Text().nullable().optional(), followUp: Text().nullable().optional(),
    categoryId: z.string().nullable().optional(), active: z.boolean().optional(), sort: Sort,
});
export const ProblemProgramItem = z.object({ programId: z.string().min(1), reason: Text(300).nullable().optional() });
export const SynonymInput = z.object({ term: Text(80).min(1), expansion: Text(300).min(1) });
export const IntentRuleInput = z.object({ pattern: Text(300).min(1), problemId: z.string().min(1), weight: Weight });
//# sourceMappingURL=kb.js.map